import React from "react";
import { ToastContainer } from "react-toastify";
import { ThemeProvider } from "styled-components";
import { ContextProvider } from "./context/Context";
import { BrowserRouter, Routes } from "react-router-dom";
import { Theme } from "./Global/Theme";
import { GlobalStyles } from "./Global/GlobalStyles";
import "react-toastify/dist/ReactToastify.css";
import { useAgendamentoRoutes } from "./routes/useAgendamentoRoutes";
import { useAgendamentoByIdRoutes } from "./routes/useAgendamentoByIdRoutes";
import { useMainRoutes } from "./routes/useMainRoutes";
import { useNovoAgendamentoRoutes } from "./routes/useNovoAgendamentoRoutes";
import { useSettingsRoutes } from "./routes/useSettingsRoutes";
import { QueryClientProvider, QueryClient } from "@tanstack/react-query";
import { useAgendamentoLoteRoutes } from "./routes/useAgendamentoLoteRoutes";
import { useAgendamentoLoteByIdRoutes } from "./routes/useAgendamentoLoteByIdRoutes";

const queryClient = new QueryClient();
export const App = () => {
  const AgendamentoRoutes = useAgendamentoRoutes();
  const AgendamentoByIdRoutes = useAgendamentoByIdRoutes();
  const MainRoutes = useMainRoutes();
  const NovoAgendamentoRoutes = useNovoAgendamentoRoutes();
  const SettingsRoutes = useSettingsRoutes();
  const AgendamentoLoteRoutes = useAgendamentoLoteRoutes();
  const AgendamentoLoteByIdRoutes = useAgendamentoLoteByIdRoutes();

  return (
    <ThemeProvider theme={Theme[process.env.REACT_APP_PROJECT]}>
      <QueryClientProvider client={queryClient}>
        <ToastContainer autoClose={2000} />
        <GlobalStyles />
        <ContextProvider>
          <BrowserRouter>
            <Routes>
              {MainRoutes}
              {AgendamentoRoutes}
              {AgendamentoByIdRoutes}
              {NovoAgendamentoRoutes}
              {SettingsRoutes}
              {AgendamentoLoteRoutes}
              {AgendamentoLoteByIdRoutes}
            </Routes>
          </BrowserRouter>
        </ContextProvider>
      </QueryClientProvider>
    </ThemeProvider>
  );
};
